import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { createContext, useContext } from 'react';
export var ProductDependenciesContext = /*#__PURE__*/createContext({
  // AI and Company Hub
  isCompanyHub: true,
  isAdminHubAIEnabled: false,
  helpCenterAri: '',
  showConfigPreamble: true,
  // Shortcuts
  shortcutListener: undefined,
  // Smart cards
  smartCardProviderComponent: undefined,
  // Custom search configuration
  orgId: '',
  userId: '',
  searchConfigProvider: {
    peopleDirectoryUrl: '',
    advancedSearchUrl: '',
    searchSessionId: ''
  },
  displayName: '',
  // Theming
  isSSRProductInDarkMode: undefined,
  branding: undefined,
  hideExtensionBorders: false,
  // Feedback collection
  useFeedbackCollector: undefined,
  // Media providers
  cloudId: '',
  useMediaConfig: undefined,
  createEditorMediaProvider: function createEditorMediaProvider() {
    return Promise.resolve({
      viewMediaClientConfig: {
        authProvider: function () {
          var _authProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", {});
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function authProvider() {
            return _authProvider.apply(this, arguments);
          }
          return authProvider;
        }()
      },
      uploadMediaClientConfig: {
        authProvider: function () {
          var _authProvider2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", {});
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function authProvider() {
            return _authProvider2.apply(this, arguments);
          }
          return authProvider;
        }()
      }
    });
  },
  // Error handling
  submitError: function submitError() {},
  markErrorAsHandled: function markErrorAsHandled() {},
  errorDisplayComponent: function errorDisplayComponent() {
    return null;
  },
  errorBoundaryComponent: undefined,
  // Premium upsells
  ConfigUpsellScreen: undefined,
  // Experience tracking
  mediaUploadExperienceTracker: undefined,
  aiDescriptionExperienceTracker: undefined,
  experienceSuccessComponent: function experienceSuccessComponent() {
    return null;
  },
  experienceStopComponent: function experienceStopComponent() {
    return null;
  },
  experienceStartComponent: function experienceStartComponent() {
    return null;
  },
  // Analytics
  analyticsContext: {},
  // User segmentation
  useSegmentationTargetGroups: function useSegmentationTargetGroups() {},
  isTargetAudience: function isTargetAudience() {
    return false;
  },
  // Link picker configuration
  linkPickerConfig: {},
  agent: {
    agentComponent: undefined,
    floatingComponent: undefined,
    agentPreviewComponent: undefined
  },
  ConfigPanelCustomMessageContent: undefined
});
export var ProductDependenciesProvider = function ProductDependenciesProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var defaultValue = useContext(ProductDependenciesContext);
  var value = _objectSpread(_objectSpread({}, defaultValue), props);
  return /*#__PURE__*/React.createElement(ProductDependenciesContext.Provider, {
    value: value
  }, children);
};
export function useProductDependencies() {
  var ctx = useContext(ProductDependenciesContext);
  if (!ctx) {
    throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
  }
  return ctx;
}